import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import Glitch from "./Glitch";
let ErrorBoundary = class ErrorBoundary extends Component {
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/1a9431f33abe2c9123909b295c4531f3d35637b0/types/react/index.d.ts#L641
    componentDidCatch(error, info) {
        this.setState({
            error,
            info
        });
    }
    render() {
        const { children  } = this.props;
        const { error , info  } = this.state;
        if (error !== null) return /*#__PURE__*/ _jsx(Glitch, {
            error: error,
            info: info || undefined
        });
        return children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null,
            info: null
        };
    }
};
export default ErrorBoundary;
